import * as React from 'react';
import { Flex, Box } from '@lightspeed/flame/Core';

const PageLayout: React.FunctionComponent = ({ children }) => {
  return (
    <Flex justifyContent="center">
      <Box maxWidth="1056px" width="1056px" mb={6} mt={6}>
        {children}
      </Box>
    </Flex>
  );
};

export { PageLayout };
